<template>
  <div>

    <main class="fix">
      <section class="breadcrumb__area breadcrumb__bg">
        <div class="container">
          <div class="row mt-5">
            <div class="col-lg-6">
              <div class="breadcrumb__content">
                <h2 class="title">Formulir</h2>
                <nav aria-label="breadcrumb">
                  <ol class="breadcrumb">
                    <li class="breadcrumb-item"><a href="javascript:void(0);" @click="$router.push('/')">Beranda</a>
                    </li>
                    <li class="breadcrumb-item active" aria-current="page">Formulir</li>
                  </ol>
                </nav>
              </div>
            </div>
          </div>
        </div>
        <div class="breadcrumb__shape">
          <img src="assets/img/images/breadcrumb_shape01.png" alt="Apexa" class="dark-opacity" />
          <img src="assets/img/images/breadcrumb_shape02.png" alt="Apexa" class="rightToLeft dark-opacity" />
          <img src="assets/img/images/breadcrumb_shape03.png" alt="Apexa" class="dark-opacity" />
          <img src="assets/img/images/breadcrumb_shape04.png" alt="Apexa" class="dark-opacity" />
          <img src="assets/img/images/breadcrumb_shape05.png" alt="Apexa" class="alltuchtopdown dark-opacity" />
        </div>
      </section>

      <section class="blog_area mt-5">
        <div class="container">
          <div class="row gutter-24 justify-content-center">
            <div class="col-lg-12" v-for="data in list_data" :key="data.id">
              <div class="features__item-two">
                <div class="features__icon-two">
                  <i class="flaticon-startup"></i>
                </div>
                <div class="features__content-two">
                  <h4 class="title"><a href="javascript:void(0)" data-bs-toggle="modal" data-bs-target="#exampleModal" @click="selectData(data)">{{ data.judul }}</a></h4>
                  <p>{{ data.keterangan }}</p>
                </div>
              </div>
            </div>
          </div>

          <div class="pagination-wrap mt-40">
            <nav aria-label="Page navigation example">
              <ul class="pagination list-wrap">
                <li class="page-item"><a class="page-link" href="javascript:void(0);" @click="btn_prev" id="pref"><i class="fas fa-angle-double-left"></i></a></li>
                <li class="page-item"><a class="page-link" href="javascript:void(0);">{{ page_first }}</a></li>
                <li class=""><a class="page-link border-0" href="javascript:void(0);">-</a></li>
                <li class="page-item"><a class="page-link" href="javascript:void(0);">{{ page_last }}</a></li>
                <li class="page-item next-page"><a class="page-link" href="javascript:void(0);" @click="btn_next"><i class="fas fa-angle-double-right"></i></a></li>
              </ul>
            </nav>
          </div>

          <div class="modal fade" id="exampleModal" tabindex="-1"
            aria-hidden="true">
            <div class="modal-dialog modal-lg">
              <div class="modal-content">
                <div class="modal-header">
                  <h5 class="modal-title">Lampiran</h5>
                  <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>
                <div class="modal-body">
                  <iframe :src="file_path+form.file" width="100%" height="680px"></iframe>
                </div>
                <div class="modal-footer">
                  <button type="button" class="blog__post-tag-two" data-bs-dismiss="modal">Keluar</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </main>
  </div>
</template>

<script>
import UMUM from '../../library/umum'

export default {

  data() {
    return {
      data_load: false,
      form: {
        id: '',
        judul: '',
        sumber: '',
        deskripsi: '',
        uraian: '',
        foto: '',
        unit_kerja: '',
        status: '',
        keterangan: '',
      },

      id: '',
      file_path: this.$store.state.url.URL_APP + "uploads/",
      UMUM: UMUM,

      list_data: [],
      page_first: 1,
      page_last: 0,
      cari_value: "",
      kategori: "Formulir",
    }
  },
  methods: {
    getView: function () {
      fetch(this.$store.state.url.URL_DOKUMEN + "view", {
        method: "POST",
        headers: {
          "content-type": "application/json",
        },
        body: JSON.stringify({
          data_ke: this.page_first,
          cari_value: this.cari_value,
          kategori: this.kategori,
        })
      })
        .then(res => res.json())
        .then(res_data => {
          this.list_data = res_data.data;
          this.page_last = res_data.jml_data;
          // console.log(res_data);

        });
    },

    selectData: function (data) {
      this.form = {
        id: data.id,
        judul: data.judul,
        file: data.file,
      };
    },

    btn_prev: function () {
      if (this.page_first > 1) {
        this.page_first--
      } else {
        this.page_first = 1;
      }
      this.getView();
    },

    btn_next: function () {

      if (this.page_first >= this.page_last) {
        this.page_first == this.page_last
      } else {
        this.page_first++;
      }
      this.getView();
    },

    cari_data: function () {

      this.page_first = 1;
      this.getView();
    },
    // ================== PAGINASI ====================
  },
  // =============================================================== METHODS =========================================================================

  mounted() {

    this.getView();

  }
};
</script>

<style></style>